import * as React from "react"
import { useLocation } from '@reach/router'
import { usePost } from '~/contexts/PostContext'
import { jnstyls, notBlank } from '~/utils/helpers'

// import TilePage from '@/components/tiles/tile-page'
import TilePage from '~/components/tile/tile-page'

// import { tiles } from "@/styles/plp/plp.module.scss"
import { tiles } from "~/styles/plp/plp.module.scss"
import * as styles from "~/styles/blog/blog-coll.module.scss"
import * as bstyle from "~/styles/blog/blog.module.scss"


const BlogColl = ({ blockId, index }) => {
  const { post } = usePost()
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block
  
  const location = useLocation()

  const image = '//checkout.buckmason.com/cdn/shop/t/2/assets/stories_collection_600x.png?v=135301280702629050441653347652'
  const products = notBlank(settings.products) ? settings.products : []

  return (
    <div 
      className={jnstyls([styles.coll, bstyle.sec])}
      block={block.id}
    >
      {notBlank(settings.show_title) && (
        <h3 className={bstyle.title}>
          <img className={bstyle.title_img} src={image} alt={settings.text} height={80} width={150} />
        </h3>
      )}
      {notBlank(settings.title) && (
        <h3 className={bstyle.title} dangerouslySetInnerHTML={{ __html: settings.title }} />
      )}
      <div 
        className={jnstyls([tiles, styles.tiles])}
        style={{width: '100%'}}
      >
        {products.map( (product,index) => 
          <TilePage 
            key={product.handle} 
            product={product} 
            tile_ind={0} 
            page_type={location.pathname.includes('/products') ? 'pdp recommendation' : false} 
          />
        )}
      </div>
    </div>
  )
}

export default BlogColl